module.exports = __webpack_public_path__ + "static/media/bg-2.f8588cb7.png";